const breakpoints = {
  unit: 'em',
  phone: 36, // 576px
  tablet: 48, // 768px
  desktop: 80, // 1280px
};

export default breakpoints;
